import Vue from 'vue';
import Toasted from 'vue-toasted';
import Router from 'vue-router';
Vue.use(Toasted, {
    Router
});

export default () => {
    // options to the toast
    const optionsError = {
        type: 'error',
        icon: 'error_outline',
        position: 'top-right',
        duration: 1000
    };

    const optionsSuccess = {
        type: 'success',
        icon: 'check',
        position: 'top-right',
        duration: 1000
    };

    // register the toast with the custom message
    Vue.toasted.register('errorMsg', function (msg) {
        if (!msg) {
            return "Oops Something wrong"
        }
        return msg
    }, optionsError)
    Vue.toasted.register('successMsg', function (msg) {
        if (!msg) {
            return "Success.. You're done!"
        }
        return msg

    }, optionsSuccess)

}
